import TimeEntryInput from './time-entry-input.html';
import controller from './time-entry-input.controller';

let timeEntryInputComponent = {
  restrict: 'E',
  template: TimeEntryInput,
  controller,
  controllerAs: '$ctrl',
  bindings: {
    timeEntry: '='
  },
};

export default timeEntryInputComponent;



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/time-entry-input/time-entry-input.component.js